var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-card"},[_c('card-featured',{attrs:{"title":_vm.title,"image":_vm.image,"alt":_vm.alt,"link":_vm.link}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }